export default "__VITE_ASSET__BKUKJYfy__"